import React from "react";
import OPOnlineIframe from "../../../iframe-component/operation-online/OPOnIframe";

const AddOnlineMerchantIframe = () => {
  return <OPOnlineIframe path="/online-pay/merchant/create" />;
};

export default React.memo(AddOnlineMerchantIframe);
